module.exports = __webpack_public_path__ + "img/blueLeader.f67c41f0.svg";